import React from 'react'

function Instructions(props) {
    const {value,type} = props
  return (
    <div>
       {type === "instruction" && <p style={{whiteSpace:"pre-line"}}>{value}</p>}
       {type === "set_scholarship" && <p style={{whiteSpace:"pre-line"}}>{value}</p> }
       {type === "set_loan" && <p className='font-mono text-justify' style={{whiteSpace:"pre-line"}}>{value}</p> }
      
     
    </div>
  )
}

export default Instructions
